import LinearProgress from '@mui/material/LinearProgress';
import {Paper} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DrawerContext from "../../../Context/DrawerContext"
import UserPositionForm from "../../../Components/Forms/Pages/HR/UserPosition/UserPositionForm";
import strings from "../../../localization";
import { addUserPosition, getUserPositions } from "../../../Services/Company/UserPositionService";
import SnackbarContext from '../../../Context/SnackbarContext';

const formRules = {
    'name': {required: true}
}

const AddUserPosition = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.userPosition.addUserPosition.pageTitle);
    });

    useEffect(() => {
        fetch();
    }, [])

    const fetch = (term = '') =>{

        getUserPositions({term}).then(response => {
            if (!response || !response.ok){
                return;
            }
            setParents(response.data.result);
        });
        }

    const onSubmit = (data) => {
        setShowLoader(true);

        addUserPosition(data).then(response => {
            setShowLoader(false);

            if(!response || !response.ok){
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <UserPositionForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents} onChangeUserFilter={fetch}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()} />
        </Paper>
    </div>
}

export default AddUserPosition;